import apiAnimals from "../config/api_animals";
// import axios from "axios";
import getHeaders from "./getHeaders";

// const apiAnimals = axios.create({
//   baseURL: "http://localhost:8084",
// });

export function getAnimalsPregnancyDiagnosis(payload) {
  const { groupId, farmId, search, page, size, sort, signal } = payload;

  const orderS =
    Object.entries(sort).length > 0 && sort.order
      ? sort.order === "descend"
        ? "DESC"
        : sort.order === "ascend"
        ? "ASC"
        : "DESC"
      : "DESC";

  const requestParams = `page=${page > 0 ? page - 1 : 0}&size=${size ?? 10}${
    sort && Object.entries(sort).length > 0 && sort.order
      ? `&sort=${sort.field}&direction=${orderS}`
      : ""
  }${search && search !== "" ? `&search=${search}` : ""}`;

  return apiAnimals.get(
    `/bovexo/${groupId}/farms/${farmId}/animals/pregnancy/diagnosis?${requestParams}`,
    getHeaders(false, signal)
  );
}

export function saveAnimalPregnancyDiagnosis(payload) {
  const { groupId, farmId, body, signal } = payload;

  return apiAnimals.post(
    `/bovexo/${groupId}/farms/${farmId}/animals/pregnancy/diagnosis`,
    body,
    getHeaders(false, signal)
  );
}

export function deleteAnimalPregnancyDiagnosis(payload) {
  const { groupId, farmId, id, signal } = payload;

  return apiAnimals.delete(
    `/bovexo/${groupId}/farms/${farmId}/animals/pregnancy/diagnosis/${id}`,
    getHeaders(false, signal)
  );
}
